<template>
  <div class="otp-mobile">
    <div class="title">تایید کد</div>
    <div class="timer">
      <p class="text-info">کد ارسال شده به تلفن همراه خود را وارد کنید</p>
      <span>2:00</span>
    </div>
    <div class="email">
      <img src="../../assets/icon/phone.png" alt="">
      <span>0912-***-5689</span>
    </div>
    <custom-input type="email" placeholder="کد ارسالی" auth="auth" />
    <button @click="$router.push('/auth/login')" class="blue-btn"> تایید</button>
  </div>
</template>

<script>
import CustomInput from "../tools/custom-input";
export default {
  name: "otp-mobile",
  components: {CustomInput}
}
</script>

<style lang="scss" scoped>
.otp-mobile {
  display: flex;
  flex-direction: column;
  gap: 30px;
  direction: rtl;
  color: #FBFBFD;
  justify-content: center;
  align-items: center;

  .email{
    display: flex;
    width: 100%;
    flex-direction: row;
    gap: 10px;
    font-size: clamp(10px , 2vw , 12px);
    img{
      width: 16px;
      height: 13px;
    }
  }

  .timer{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;

    span{
      color: #1199FA;
    }
  }

  .title{
    font-size: clamp(18px , 2vw , 22px);
    font-weight: bold;
  }

  .text-info{
    font-size: clamp(12px , 2vw , 14px);
    text-align: right;
    width:100%;
  }

  button{
    width: 100%;
  }

  label{
    position: relative;
    width: 100%;
    img{
      position: absolute;
      left: 16px;
      top: 35%;
    }
  }
}
</style>